import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Common/Configurations/AuthContext";
import Header from "../../../Common/Layout/Header";
import BusOffers from "../../../Components/Advertisements/BusOffers";
import SearchBusPanel2 from "../SearchBusPanel/SearchBusPanel2";
import styles from "./SearchBus2.module.css";

const SearchBus2 = ({ mode, onNavigate, templateId, branding }) => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  const handleSearch = (searchQuery) => {
     // 👇 Use the 3-mode logic
     if (mode === "builder") {
         onNavigate({ name: "bus-results", params: { searchQuery } });
     } else if (mode === "preview") {
         navigate(`/template-preview/${templateId}/bus-results`, { state: { searchQuery } });
     } else {
         navigate("/template/bus/results", { state: { searchQuery } });
     }
   };

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
    
      
      {/* Hero Section with Modern Bus Image */}
      <section className={styles.heroSection}>
        <div className={styles.heroOverlay}>
          <div className={styles.heroContent}>          

            {/* Main Hero Text */}
            <div className={styles.heroText}>             
              <h4 className={styles.heroTitle}>
                Welcome
              </h4>
              <p className={styles.heroSubtitle}>
                Experience luxury, comfort and technology in every journey
              </p>
            </div>


            {/* Search Component */}
            <div className={styles.searchWrapper}>
              <SearchBusPanel2 onSearch={handleSearch} />
            </div>

            {/* Bottom Feature Cards */}
           
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <BusOffers />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBus2;